import type { DashboardPeriod } from '~/app/services/organization-manager-dashboard/organization-manager-dashboard.types';
import { operationsKpisForPeriod } from './operations-kpi.mock';
import type { GetOperationsKpisResponseDto } from './operations-kpi.types';

/**
 * Operations KPIs for the organization-manager dashboard.
 *
 * Today: typed mock so the screens render before the operations KPI route is on main.
 * Later: replace `getKpis` with fetch / generated client — keep the DTO
 * and pass `period` as a query param.
 */
export const OperationsKpiService = {
  async getKpis(
    period: DashboardPeriod,
  ): Promise<GetOperationsKpisResponseDto> {
    await new Promise((resolve) => setTimeout(resolve, 150));
    return operationsKpisForPeriod(period);
  },
};
